import React from 'react';

export function AssignmentIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M14 30h14v4H14v-4zm0-8h20v4H14v-4zm0-8h20v4H14v-4zm24-8h-8.36C28.8 3.68 26.6 2 24 2c-2.6 0-4.8 1.68-5.64 4H10c-.28 0-.54.02-.8.08-.78.16-1.48.56-2.02 1.1-.36.36-.66.8-.86 1.28-.2.46-.32.98-.32 1.54v28c0 .54.12 1.08.32 1.56s.5.9.86 1.28c.54.54 1.24.94 2.02 1.1.26.04.52.06.8.06h28c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4zm-14-.5c.82 0 1.5.68 1.5 1.5s-.68 1.5-1.5 1.5-1.5-.68-1.5-1.5.68-1.5 1.5-1.5zM38 37a1 1 0 01-1 1H11a1 1 0 01-1-1V11a1 1 0 011-1h26a1 1 0 011 1v26z" />
    </svg>
  );
}
